'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://boiling-garden-84845.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client3.js